import React, { useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import Input from 'components/Input/Input';
import type { UserPartialType } from 'types/apiTypes/userApiTypes';
import { useUpdateUserByIdMutation } from 'api/services/dataEndpoints';
import useDebounce from 'utils/useDebounce';
import Checkbox from 'components/Checkbox/Checkbox';
import { BoxForm } from './UserInfo.styles';

interface IUserInfoProps {
  data: UserPartialType;
}

const UserInfo: React.FC<IUserInfoProps> = ({ data }) => {
  const [updateUser, { isLoading }] = useUpdateUserByIdMutation();
  const [name, setName] = React.useState<string>(data?.name || '');
  const [phone, setPhone] = React.useState<string>(data?.phone || '');
  const [isManager, setIsManager] = React.useState<boolean>(data?.is_staff || false);

  useEffect(() => {
    setPhone(data.phone || '');
  }, [data.phone]);
  useEffect(() => {
    setName(data.name || '');
  }, [data.name]);

  const debouncedName = useDebounce(name, 500);
  const debouncedPhone = useDebounce(phone, 500);
  const debouncedManager = useDebounce(isManager, 500);

  React.useEffect(() => {
    if (
      debouncedName !== data?.name ||
      debouncedPhone !== data?.phone ||
      debouncedManager !== data?.is_staff
    ) {
      updateUser({
        id: data?.id,
        data: { name: debouncedName, phone: debouncedPhone, is_staff: debouncedManager },
      });
    }
  }, [
    data?.id,
    data?.name,
    data?.phone,
    data?.is_staff,
    debouncedName,
    debouncedPhone,
    debouncedManager,
    updateUser,
  ]);

  return (
    <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        User info
      </Typography>
      <BoxForm>
        <Input
          label="Name"
          value={name}
          nameInput="name"
          onChangeValue={(ev) => {
            setName(ev.target.value);
          }}
        />
        <Input
          label="Phone"
          value={phone}
          nameInput="phone"
          onChangeValue={(ev) => {
            setPhone(ev.target.value);
          }}
        />
        <Checkbox
          title="Is manager"
          value={data?.is_staff}
          onChange={(ev) => {
            setIsManager(ev.target.checked);
          }}
        />
      </BoxForm>
    </Paper>
  );
};

export default UserInfo;
